import { render } from "./Blog-category-editor.vue?vue&type=template&id=517859e7&scoped=true"
import script from "./Blog-category-editor.vue?vue&type=script&lang=js"
export * from "./Blog-category-editor.vue?vue&type=script&lang=js"

import "./Blog-category-editor.vue?vue&type=style&index=0&id=517859e7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-517859e7"]])

export default __exports__